import { useSnapshot } from "valtio";
import { useState, useEffect } from "react";
import uiState from "../data";
import { windowSizeState } from "../utils/windowSize";
import { AnimatePresence, motion } from "framer-motion";
import { googleSheet } from "../utils/getSheet";

const EnvironmentSpa = ({ event }) => {
  const { visible } = useSnapshot(uiState[event]);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [movementDirection, setMovementDirection] = useState(null);
  const [scrollStatus, setScrollStatus] = useState(null);
  const [currentScrollY, setCurrentScrollY] = useState(0);
  const { vh } = useSnapshot(windowSizeState);

  const [showLogoFilter, setShowLogoFilter] = useState(false);
  const { mobileMode } = useSnapshot(windowSizeState);

  const data = googleSheet["homepage"].filter((el) => {
    return el.part === "sustainability_spa";
  })[0];

  // GA
  function gtag() {
    window.dataLayer.push(arguments);
  }

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const deltaX = clientX - mousePosition.x;
    const deltaY = clientY - mousePosition.y;

    // 判斷滑鼠移動的方向
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      if (deltaX > 0) {
        setMovementDirection("right");
      } else if (deltaX < 0) {
        setMovementDirection("left");
      }
    } else {
      if (deltaY > 0) {
        setMovementDirection("bottom");
      } else if (deltaY < 0) {
        setMovementDirection("top");
      }
    }

    setMousePosition({ x: clientX, y: clientY });
  };

  useEffect(() => {
    const handleScroll = (e) => {
      setCurrentScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    // 第一頁scroll字樣的動畫
    if (currentScrollY < 0.4 * vh) {
      setScrollStatus("leavePage2");
    } else {
      setScrollStatus("enterPage2");
    }
    // logo底圖出現的計算
    if (currentScrollY > 120) {
      setShowLogoFilter(true);
    } else {
      setShowLogoFilter(false);
    }
  }, [currentScrollY, vh]);

  const goSus = (gaNumber, panoID, isVentilation) => {
    gtag(
      "event",
      `homepage sustainability:select ${data[`en_title${gaNumber}`]}`
    );

    let bgm = document.getElementById("bgm");

    uiState.bgm.bgmSrc = "../startImages/music/sus.mp3";
    sessionStorage.setItem("susInit", true);
    sessionStorage.setItem("activeWeb", "sus");
    sessionStorage.setItem("isVentilation", isVentilation);
    setTimeout(() => {
      sessionStorage.setItem("goPano", panoID);
    }, 100);

    setTimeout(() => {
      if (sessionStorage.getItem("introState") !== "close") {
        sessionStorage.setItem("introState", "init");
      } else {
        if (uiState.bgm.isMusicPlay && bgm) {
          bgm.currentTime = 0;
          bgm.play();
        }
      }
      uiState.susIframe.visible = true;
    }, 400);
  };

  return (
    <>
      <AnimatePresence>
        {visible && mobileMode && (
          <motion.div
            className="w-full overflow-hidden line"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <motion.div>
              <img
                src="../startImages/icon/back.png"
                alt="返回鍵"
                className={`fixed top-[80px] portraitPad:top-[70px]  left-[180px] portraitPad:left-[10%] landscapePad:left-[10%] authPCHeight:left-[10%]  w-[110px] portraitBigPh:w-[70px] portraitBigPh:top-[50px] landscapePhone:w-[70px] landscapePhone:top-[50px] landscapePhone:left-[10%] cursor-pointer z-30 ${
                  !mobileMode && "opacity-70"
                } hover:opacity-100 `}
                onClick={() => {
                  uiState.enterPage.visible = true;
                  uiState[event].visible = false;
                }}
              />
              <div className="fixed top-0 left-1/2 -translate-x-1/2 h-full flex flex-col justify-between z-30 pointer-events-none">
                <div className="flex flex-col items-center">
                  <div>
                    <img
                      src="../startImages/logo/color.png"
                      alt="logo 彩色部分"
                      className="w-[50px]  portraitBigPh:w-[30px] landscapePhone:w-[30px]"
                    />
                  </div>
                  <div>
                    <img
                      src="../startImages/logo/big_logo.png"
                      alt="黑色 logo"
                      className="w-[100px]  portraitBigPh:w-[75px] landscapePhone:w-[75px]"
                    />
                  </div>
                </div>
              </div>

              {/* logo下的色塊 */}
              <AnimatePresence>
                {showLogoFilter && (
                  <motion.div
                    className="fixed top-0 left-0 h-[220px] portraitBigPh:h-[200px] w-full z-20 bg-gradient-to-b from-white to-transparent pointer-events-none"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                  ></motion.div>
                )}
              </AnimatePresence>

              <div className="w-full  relative mainBgPh flex flex-col items-center">
                {/* 第一頁 */}
                <img
                  src="../startImages/pic/Mask_group.png"
                  alt="圖片1"
                  className=" w-[650px] scale-[1.2] translate-x-[180px] mt-[170px] portraitBigPh:w-[300px] portraitBigPh:scale-[1.5] portraitBigPh:translate-x-[100px] portraitBigPh:mt-[155px]"
                />
                <div className=" w-[95%] px-4 flex flex-col justify-center mt-[100px]">
                  <p className="Trajan text-[24px] portraitPh:text-[18px]">
                    {data.en_title1}
                  </p>
                  <p className="text-[16px] jf mt-4 portraitPh:text-[15px] portraitBigPh:mt-2 ">
                    {data.en_content1}
                  </p>
                </div>

                {/* 第二之一頁 */}
                <div className="relative w-full flex justify-center">
                  <img
                    src="../startImages/pic/Solar_Energy_System.jpg"
                    alt="佔位圖"
                    className="w-[65%] mt-[15%] invisible portraitBigPh:w-[75%]"
                  />
                  <img
                    src="../startImages/pic/Solar_Energy_System.jpg"
                    alt="圖片2-1"
                    className="w-[65%] mt-[15%] absolute top-0 left-1/2 -translate-x-1/2 z-10 portraitBigPh:w-[75%]"
                  />
                  <div className="w-[55%] aspect-[1/1.3] portraitBigPh:aspect-[1/1.55] bg-spaBlue-100 absolute top-[32%] left-0 "></div>
                </div>
                <div className=" w-[70%]  px-8 flex flex-col justify-center z-10 mt-6 portraitBigPh:w-[80%] portraitBigPh:px-4 portraitBigPh:mt-4 ">
                  <p className="Trajan text-[24px]  portraitBigPh:text-[18px]">
                    {data.en_title2}
                  </p>
                  <p className="text-[16px] jf mt-4 portraitBigPh:text-[15px]  portraitBigPh:mt-2">
                    {data.en_content2}
                  </p>
                  <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                    <button
                      className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                      onClick={() => {
                        goSus(2, "pano1661", false);
                      }}
                    >
                      {data.en_btn1}
                    </button>
                  </div>
                </div>

                {/* 第二之二頁 */}
                <div className="relative flex justify-center w-full ">
                  <img
                    src="../startImages/pic/Water_Welding_Technique.jpg"
                    alt="佔位圖"
                    className="w-[65%] mt-[15%] invisible portraitBigPh:w-[75%]"
                  />
                  <img
                    src="../startImages/pic/Water_Welding_Technique.jpg "
                    alt="圖片2-2"
                    className="w-[65%] mt-[15%] absolute top-0 left-1/2 -translate-x-1/2 z-10 portraitBigPh:w-[75%]"
                  />
                  <div className="w-[94%] aspect-[1/0.78] portraitBigPh:aspect-[1/1.28] bg-spaOrange-100 absolute top-[58%] right-0 "></div>
                </div>
                <div className=" w-[70%]  px-8 flex flex-col justify-center z-10 mt-6 portraitBigPh:w-[85%] portraitBigPh:px-4 portraitBigPh:mt-4 ">
                  <p className="Trajan text-[24px]  portraitBigPh:text-[18px] text-white">
                    {data.en_title3}
                  </p>
                  <p className="text-[16px] jf mt-4 portraitBigPh:text-[15px]  portraitBigPh:mt-2 text-white">
                    {data.en_content3}
                  </p>
                  <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                    <button
                      className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                      onClick={() => {
                        goSus(3, "pano1706", false);
                      }}
                    >
                      {data.en_btn1}
                    </button>
                  </div>
                </div>

                {/* 第三之一頁 */}
                <div></div>
                <div className="relative flex justify-center w-full ">
                  <img
                    src="../startImages/pic/Lead_free_Soldering.jpg"
                    alt="佔位圖"
                    className="w-[65%] mt-[17%] invisible portraitBigPh:w-[75%]"
                  />
                  <img
                    src="../startImages/pic/Lead_free_Soldering.jpg"
                    alt="圖片3-1"
                    className="w-[65%] mt-[17%] absolute top-0 left-1/2 -translate-x-1/2 z-10 portraitBigPh:w-[75%]"
                  />
                  <div className="w-[75%] aspect-[1/0.8] portraitBigPh:aspect-[1/1.25] bg-spaGreen-100 absolute top-[58%] right-0 "></div>
                </div>
                <div className=" w-[70%]  px-8 flex flex-col justify-center z-10 mt-6 portraitBigPh:w-[80%] portraitBigPh:px-4 portraitBigPh:mt-4 ">
                  <p className="Trajan text-[24px]  portraitBigPh:text-[18px] ">
                    {data.en_title4}
                  </p>
                  <p className="text-[16px] jf mt-4 portraitBigPh:text-[15px]  portraitBigPh:mt-2 ">
                    {data.en_content4}
                  </p>
                  <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                    <button
                      className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                      onClick={() => {
                        goSus(4, "pano1679", false);
                      }}
                    >
                      {data.en_btn1}
                    </button>
                  </div>
                </div>

                {/* 第三之二頁 */}
                <div className="relative flex justify-center w-full ">
                  <img
                    src="../startImages/pic/Ventilation_Mechanism.jpg"
                    alt="佔位圖"
                    className="w-[65%] mt-[25%] invisible portraitBigPh:w-[75%]"
                  />
                  <img
                    src="../startImages/pic/Ventilation_Mechanism.jpg"
                    alt="圖片3-2"
                    className="w-[65%] mt-[25%] absolute top-0 left-1/2 -translate-x-1/2 z-10 portraitBigPh:w-[75%]"
                  />
                  <div className="w-[70%] aspect-[1/1.1] portraitBigPh:aspect-[1/1.25] bg-spaBlue-100 absolute top-[14%] right-0 "></div>
                </div>
                <div className=" w-[70%]  px-8 flex flex-col justify-center z-10 mt-[2%] portraitBigPh:w-[85%] portraitBigPh:px-4 portraitBigPh:mt-4 ">
                  <p className="Trajan text-[24px]  portraitBigPh:text-[18px] ">
                    {data.en_title5}
                  </p>
                  <p className="text-[16px] jf mt-4 portraitBigPh:text-[15px]  portraitBigPh:mt-2 ">
                    {data.en_content5}
                  </p>
                  <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                    <button
                      className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                      onClick={() => {
                        goSus(5, "pano1706", true);
                      }}
                    >
                      {data.en_btn1}
                    </button>
                  </div>
                </div>

                {/* 第四之一頁 */}
                <div className="relative flex justify-center w-full ">
                  <img
                    src="../startImages/pic/Walnut_Polishing.jpg"
                    alt="佔位圖"
                    className="w-[65%] mt-[15%] invisible portraitBigPh:w-[75%]"
                  />
                  <img
                    src="../startImages/pic/Walnut_Polishing.jpg"
                    alt="圖片4-1"
                    className="w-[65%] mt-[15%]  absolute top-0 left-1/2 -translate-x-1/2 z-10 portraitBigPh:w-[75%]"
                  />
                  <div className="w-full aspect-[1/0.8] portraitBigPh:aspect-[1/1.25] bg-spaOrange-100 absolute top-[42%] right-0 "></div>
                </div>
                <div className=" w-[70%]  px-8 flex flex-col justify-center z-10 portraitBigPh:w-[80%] portraitBigPh:px-4 -mt-[20px] ">
                  <p className="Trajan text-[24px]  portraitBigPh:text-[18px] text-white ">
                    {data.en_title6}
                  </p>
                  <p className="text-[16px] jf mt-4 portraitBigPh:text-[15px]  portraitBigPh:mt-2 text-white ">
                    {data.en_content6}
                  </p>
                  <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                    <button
                      className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                      onClick={() => {
                        goSus(6, "pano1664", false);
                      }}
                    >
                      {data.en_btn1}
                    </button>
                  </div>
                </div>

                {/* 第五之一頁 （金屬回收）*/}
                <div className="relative w-full flex justify-center">
                  <img
                    src="../startImages/pic/Metal_Remnants_Recycling_and_Reuse.jpg"
                    alt="佔位圖"
                    className="w-[65%] mt-[15%] invisible portraitBigPh:w-[75%]"
                  />
                  <img
                    src="../startImages/pic/Metal_Remnants_Recycling_and_Reuse.jpg"
                    alt="圖片5"
                    className="w-[65%] mt-[15%] absolute top-0 left-1/2 -translate-x-1/2 z-10 portraitBigPh:w-[75%]"
                  />
                  <div className="w-[55%] aspect-[1/1.3] portraitBigPh:aspect-[1/1.55] bg-spaBlue-100 absolute top-[32%] left-0 "></div>
                </div>
                <div className=" w-[70%]  px-8 flex flex-col justify-center z-10 mt-6 portraitBigPh:w-[80%] portraitBigPh:px-4 portraitBigPh:mt-4 mb-[50px]">
                  <p className="Trajan text-[24px]  portraitBigPh:text-[18px]">
                    {data.en_title7}
                  </p>
                  <p className="text-[16px] jf mt-4 portraitBigPh:text-[15px]  portraitBigPh:mt-2">
                    {data.en_content7}
                  </p>
                  <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                    <button
                      className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                      onClick={() => {
                        goSus(7, "pano1700", false);
                      }}
                    >
                      {data.en_btn1}
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* 電腦版 */}
      <AnimatePresence>
        {visible && !mobileMode && (
          <motion.div
            className="w-full "
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <motion.div onMouseMove={handleMouseMove}>
              <img
                src="../startImages/icon/back.png"
                alt="返回鍵"
                className={`fixed top-[80px] portraitPad:top-[70px]  left-[180px] portraitPad:left-[10%] landscapePad:top-[70px] smallLaptop:left-[6%] landscapePad:left-[8%] authPCHeight:left-[10%]  w-[110px] portraitBigPh:w-[70px] portraitBigPh:top-[50px] landscapePhone:w-[70px] landscapePhone:top-[50px] landscapePhone:left-[10%] cursor-pointer z-30 ${
                  !mobileMode && "opacity-70"
                } hover:opacity-100 `}
                onClick={() => {
                  uiState.enterPage.visible = true;
                  uiState[event].visible = false;
                }}
              />
              <div className="fixed top-0 left-1/2 -translate-x-1/2 h-full flex flex-col justify-between z-30 pointer-events-none">
                <div className="flex flex-col items-center">
                  <div>
                    <img
                      src="../startImages/logo/color.png"
                      alt="logo 彩色部分"
                      className="w-[50px]"
                    />
                  </div>
                  <div>
                    <img
                      src="../startImages/logo/big_logo.png"
                      alt="黑色 logo"
                      className="w-[100px]"
                    />
                  </div>
                </div>
              </div>

              {/* logo下的色塊 */}
              <AnimatePresence>
                {showLogoFilter && (
                  <motion.div
                    className="fixed top-0 left-0 h-[230px] w-full bg-gradient-to-b from-white to-transparent z-20 pointer-events-none"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                  ></motion.div>
                )}
              </AnimatePresence>

              <div className="w-full  relative  mainBgPc flex flex-col items-center overflow-hidden">
                {/* 第一頁 */}
                <div id="page1" className="screen-setting relative ">
                  <div className="h-[50%] w-[35%] absolute top-[65%]  -translate-y-1/2 left-[180px] flex flex-col justify-between items-start smallLaptop:left-[6%] smallLaptop:w-[40%] smallLaptop:top-[60%] landscapePad:left-[8%] landscapePad:top-[55%] landscapePad:w-[40%]">
                    <motion.div
                      animate={{
                        x: movementDirection === "right" ? "-10px" : "10px",
                        y: movementDirection === "top" ? "10px" : "-10px",
                      }}
                      transition={{ duration: 0.5 }}
                    >
                      <div className="Trajan text-[28px] smallLaptop:text-[24px] landscapePad:text-[24px]">
                        <p>{data.en_title1}</p>
                      </div>
                      <div className="mt-4">
                        <p className="text-[17px] jf smallLaptop:text-[16px] landscapePad:text-[16px]">
                          {data.en_content1}
                        </p>
                      </div>
                    </motion.div>
                  </div>
                  <motion.div
                    className={`absolute h-[130%] -top-[20%]  right-0 translate-x-[28%] w-[65%]  z-10   landscapePad:h-[140%] landscapePad:w-[75%] landscapePad:-top-[22%] landscapePad:-right-[5%] `}
                    animate={{
                      x: movementDirection === "right" ? "30%" : "32%",
                      y: movementDirection === "top" ? "10px" : "-10px",
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <img
                      src="../startImages/pic/Mask_group.png"
                      alt="第一頁圖片"
                      className="h-full object-contain"
                    />
                  </motion.div>

                  <div className="jf absolute bottom-[10%] left-1/2 -translate-x-1/2 text-scrollText-100 text-[17px] flex overflow-hidden">
                    <motion.div
                      className="w-[1px] h-[50px] bg-scrollText-100 mr-4"
                      animate={{
                        y: scrollStatus === "enterPage2" ? "50px" : "0px",
                      }}
                      transition={{ duration: 0.5 }}
                    ></motion.div>
                    <motion.p
                      className="leading-[50px]"
                      animate={{
                        opacity: scrollStatus === "enterPage2" ? 0 : 1,
                      }}
                      transition={{ duration: 0.5 }}
                    >
                      <p>{data.scrollTip}</p>
                    </motion.p>
                  </div>
                </div>

                {/* 第二頁左邊區域*/}
                <div className="w-full ">
                  <motion.div
                    className="w-[17%] ml-[15%] mt-[5%] smallLaptop:w-[20%] landscapePad:w-[20%] "
                    animate={{
                      x: movementDirection === "right" ? "-10px" : "10px",
                      y: movementDirection === "top" ? "10px" : "-10px",
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <img
                      src="../startImages/pic/Solar_Energy_System.jpg"
                      alt="圖片2-1"
                      className=" absolute top-0 left-0 z-10"
                    />
                    <img
                      src="../startImages/pic/Solar_Energy_System.jpg"
                      alt="佔位圖"
                      className=" invisible"
                    />
                    <motion.div
                      className="w-full aspect-[1/1.2] bg-spaBlue-100 absolute top-[40px] right-[40px]"
                      animate={{
                        x: movementDirection === "right" ? "-10px" : "10px",
                        y: movementDirection === "top" ? "10px" : "-10px",
                      }}
                      transition={{ duration: 0.5 }}
                    ></motion.div>
                    <div className="w-[160%] aspect-[1/0.6]  pl-3 absolute right-0 top-0 mt-[25%] translate-x-[100%] smallLaptop:w-[200%] landscapePad:w-[200%]  ">
                      <p className="Trajan text-[24px] ">{data.en_title2}</p>
                      <p className="text-[16px] jf mt-4">{data.en_content2}</p>
                      <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                        <button
                          className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px]  landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                          onClick={() => {
                            goSus(2, "pano1661", false);
                          }}
                        >
                          {data.en_btn1}
                        </button>
                      </div>
                    </div>
                  </motion.div>
                </div>

                {/* 第二頁右邊區域*/}
                <motion.div
                  className="w-full mr-[20%] mt-[4%] flex justify-end items-center smallLaptop:mt-[6%] landscapePad:mt-[6%]"
                  animate={{
                    x: movementDirection === "right" ? "-10px" : "10px",
                    y: movementDirection === "top" ? "10px" : "-10px",
                  }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="w-[35%] p-4 pl-8 mr-[-5%]  translate-y-[20%]   bg-spaOrange-100 landscapePad:w-[50%] smallLaptop:w-[50%] ">
                    <p className="Trajan text-[24px] text-white mr-[12%] ">
                      {data.en_title3}
                    </p>
                    <p className="text-[16px] jf mt-4 text-white  mr-[12%] ">
                      {data.en_content3}
                    </p>
                    <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                      <button
                        className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                        onClick={() => {
                          goSus(3, "pano1706", false);
                        }}
                      >
                        {data.en_btn1}
                      </button>
                    </div>
                  </div>
                  <div className="relative w-[17%] smallLaptop:w-[20%] landscapePad:w-[20%]">
                    <motion.img
                      src="../startImages/pic/Water_Welding_Technique.jpg"
                      alt="圖片2-2"
                      className=" absolute top-0 left-0 z-10 "
                      animate={{
                        x: movementDirection === "right" ? "-10px" : "10px",
                        y: movementDirection === "top" ? "10px" : "-10px",
                      }}
                      transition={{ duration: 0.5 }}
                    />
                    <img
                      src="../startImages/pic/Water_Welding_Technique.jpg"
                      alt="佔位圖"
                      className=" invisible "
                    />
                  </div>
                </motion.div>

                {/* 第三頁左邊區域*/}
                <div className="w-full ">
                  <motion.div
                    className="w-[17%] ml-[25%] mt-[8%] smallLaptop:w-[20%] smallLaptop:ml-[20%] smallLaptop:mt-[13%] landscapePad:w-[20%] landscapePad:ml-[20%] landscapePad:mt-[13%]"
                    animate={{
                      x: movementDirection === "right" ? "-10px" : "10px",
                      y: movementDirection === "top" ? "10px" : "-10px",
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <img
                      src="../startImages/pic/Lead_free_Soldering.jpg"
                      alt="圖片3-1"
                      className=" absolute top-0 left-0 z-10"
                    />
                    <img
                      src="../startImages/pic/Lead_free_Soldering.jpg"
                      alt="佔位圖"
                      className=" invisible"
                    />
                    <motion.div
                      className="w-[140%] aspect-[1/0.8] bg-spaGreen-100 absolute top-[20%] -left-[12%]"
                      animate={{
                        x: movementDirection === "right" ? "-10px" : "10px",
                        y: movementDirection === "top" ? "10px" : "-10px",
                      }}
                      transition={{ duration: 0.5 }}
                    ></motion.div>
                    <div className="w-[180%] aspect-[1/0.6]  pl-3 absolute right-0 top-0 mt-[28%] translate-x-[100%] smallLaptop:w-[220%] smallLaptop:mt-[20%] landscapePad:w-[220%] landscapePad:mt-[20%] ">
                      <p className="Trajan text-[24px] ">{data.en_title4}</p>
                      <p className="text-[16px] jf mt-4">{data.en_content4}</p>
                      <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                        <button
                          className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                          onClick={() => {
                            goSus(4, "pano1679", false);
                          }}
                        >
                          {data.en_btn1}
                        </button>
                      </div>
                    </div>
                  </motion.div>
                </div>

                {/* 第三頁右邊區域*/}
                <motion.div
                  className="w-full mr-[40%] mt-[10%] flex justify-end items-center smallLaptop:mt-[12%] landscapePad:mt-[12%]"
                  animate={{
                    x: movementDirection === "right" ? "-10px" : "10px",
                    y: movementDirection === "top" ? "10px" : "-10px",
                  }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="w-[30%] p-4  mt-[5%]  z-10 smallLaptop:w-[40%] landscapePad:w-[40%]">
                    <p className="Trajan text-[24px] ">{data.en_title5}</p>
                    <p className="text-[16px] jf mt-4">{data.en_content5}</p>
                    <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                      <button
                        className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                        onClick={() => {
                          goSus(5, "pano1706", true);
                        }}
                      >
                        {data.en_btn1}
                      </button>
                    </div>
                  </div>
                  <div className="relative w-[17%] smallLaptop:w-[20%] landscapePad:w-[20%]">
                    <motion.img
                      src="../startImages/pic/Ventilation_Mechanism.jpg"
                      alt="圖片3-2"
                      className=" absolute top-0 left-0 z-10 "
                      animate={{
                        x: movementDirection === "right" ? "-10px" : "10px",
                        y: movementDirection === "top" ? "10px" : "-10px",
                      }}
                      transition={{ duration: 0.5 }}
                    />
                    <img
                      src="../startImages/pic/Ventilation_Mechanism.jpg"
                      alt="佔位圖"
                      className=" invisible "
                    />
                    <motion.div
                      className="w-[125%] aspect-[1/1.2] bg-spaBlue-100 absolute -top-[10%] -left-[12%]"
                      animate={{
                        x: movementDirection === "right" ? "-10px" : "10px",
                        y: movementDirection === "top" ? "10px" : "-10px",
                      }}
                      transition={{ duration: 0.5 }}
                    ></motion.div>
                  </div>
                </motion.div>

                {/* 第四頁左邊區域*/}
                <motion.div
                  className="w-full ml-[45%] mt-[8%] flex justify-start items-center smallLaptop:ml-[25%] smallLaptop:mt-[4%] landscapePad:ml-[25%] landscapePad:mt-[4%]"
                  animate={{
                    x: movementDirection === "right" ? "-10px" : "10px",
                    y: movementDirection === "top" ? "10px" : "-10px",
                  }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="relative w-[17%] smallLaptop:w-[20%] landscapePad:w-[20%]">
                    <motion.img
                      src="../startImages/pic/Walnut_Polishing.jpg"
                      alt="圖片4-1"
                      className=" absolute top-0 left-0 z-10 "
                      animate={{
                        x: movementDirection === "right" ? "-10px" : "10px",
                        y: movementDirection === "top" ? "10px" : "-10px",
                      }}
                      transition={{ duration: 0.5 }}
                    />
                    <img
                      src="../startImages/pic/Walnut_Polishing.jpg"
                      alt="佔位圖"
                      className=" invisible "
                    />
                  </div>
                  <div className="w-[40%] p-4 pl-8  mt-[10%] translate-x-[18%]  bg-spaOrange-100  -ml-[13%] smallLaptop:w-[50%] landscapePad:w-[50%]">
                    <p className="Trajan text-[24px] text-white ml-[15%]">
                      {data.en_title6}
                    </p>
                    <p className="text-[16px] jf mt-4 text-white ml-[15%]">
                      {data.en_content6}
                    </p>
                    <div className="box-border  h-[40px]  ml-[15%] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                      <button
                        className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                        onClick={() => {
                          goSus(6, "pano1664", false);
                        }}
                      >
                        {data.en_btn1}
                      </button>
                    </div>
                  </div>
                </motion.div>

                <motion.div
                  className="w-full mr-[43%] mt-[8%]  mb-[6%] flex justify-end items-center smallLaptop:mr-[30%] smallLaptop:mt-[2%] smallLaptop:mb-[4%] landscapePad:mr-[30%] landscapePad:mt-[2%] landscapePad:mb-[4%]"
                  animate={{
                    x: movementDirection === "right" ? "-10px" : "10px",
                    y: movementDirection === "top" ? "10px" : "-10px",
                  }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="w-[35%] p-4  mt-[10%]  z-10 whitespace-pre-wrap smallLaptop:w-[45%] landscapePad:w-[45%]">
                    <p className="Trajan text-[24px] ">{data.en_title7}</p>
                    <p className="text-[16px] jf mt-4">{data.en_content7}</p>
                    <div className="box-border  h-[40px] flex justify-start portraitPh:h-[40px] landscapePhone:h-[40px] mt-4">
                      <button
                        className="Trajan border-spaButtonGray-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 hover:bg-mainOrange-100 hover:text-white hover:border-mainOrange-100 bg-white cursor-pointer"
                        onClick={() => {
                          goSus(7, "pano1700", false);
                        }}
                      >
                        {data.en_btn1}
                      </button>
                    </div>
                  </div>
                  <div className="relative w-[17%] smallLaptop:w-[20%] landscapePad:w-[20%]">
                    <motion.img
                      src="../startImages/pic/Metal_Remnants_Recycling_and_Reuse.jpg"
                      alt="圖片4-2"
                      className=" absolute top-0 left-0 z-10 "
                      animate={{
                        x: movementDirection === "right" ? "-10px" : "10px",
                        y: movementDirection === "top" ? "10px" : "-10px",
                      }}
                      transition={{ duration: 0.5 }}
                    />
                    <img
                      src="../startImages/pic/Metal_Remnants_Recycling_and_Reuse.jpg"
                      alt="佔位圖"
                      className=" invisible "
                    />
                    <motion.div
                      className="w-[190%] aspect-[1/0.5] bg-spaGreen-100 absolute -bottom-[10%] -right-[12%]"
                      animate={{
                        x: movementDirection === "right" ? "-10px" : "10px",
                        y: movementDirection === "top" ? "10px" : "-10px",
                      }}
                      transition={{ duration: 0.5 }}
                    ></motion.div>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default EnvironmentSpa;
